import Branding from "../../src/modules/branding";
const ACCESS_TOKEN = "ACCESS_TOKEN";
const SESSION_ID = "SESSION_ID";
const BUILDING_ID = "BUILDING_ID";
const BUILDINGS = "BUILDINGS";
const SERVER_URL = "SERVER_URL";
const SERVER_LIST = "SERVER_LIST";
const SERVER_ID = "SERVER_ID";
const PROFILES_LIST = "PROFILES_LIST";
const USER_ID = "USER_ID";
const USER_FULL_NAME = "USER_FULL_NAME";
const USER_QUICK_ACCESS = "USER_QUICK_ACCESS";
const AREA_STATE_QUICK_ACCESS = "AREA_STATE_QUICK_ACCESS";
const SCENARIO_QUICK_ACCESS = "SCENARIO_QUICK_ACCESS";
const LAST_UPDATE_CHECK = "LAST_UPDATE_CHECK";
const CLOUD_SERVER = "http://bms.taplife.ir:3030";
const WEB_MAX_WIDTH = 900;
const WARNING_MIN_BATTERY = 10;
const APP_VERSION = "4.15.0";
const DEFAULT_SERVER_ID = "defaultServer";
const WEBSOCKET_PORT = "websocketPort";
const PASSWORD_PATTERN = /^(?=.*[a-z])[A-Za-z\d#$@!%&*?]{8,30}$/;
// === http://openweathermap.org
const WEATHER_API_KEY = "429a377ba3ed9725e80ca1d6f1180d72";
const WEATHER_CITY = "WEATHER_CITY";
const ALL_PORTS = {
  http: 3030,
  https: 433,
  ws: 3031,
  wss: 3033,
};
const DEFAULT_PORTS = {
  http: 3030,
  https: 443,
  ws: 3031,
  wss: 3033,
};
const SECURE_PORTS = {
  http: null,
  https: 443,
  ws: null,
  wss: 3031,
};
const NON_SECURE_PORTS = {
  http: 3030,
  https: null,
  ws: 3031,
  wss: null,
};
const MIGRATION_VERSION = "MIGRATION_VERSION";
const CHECK_SECURE_STORAGE = "CHECK_SECURE_STORAGE";
const TRUE = "TRUE";
const FALSE = "FALSE";
// === start Branding ===
const DEFAULT_BRAND_NAME = Branding.getBrandName(); //"TapLife";
const brandHandler = (brandName = DEFAULT_BRAND_NAME) => {
  var result = {
    NAME_EN: "Default",
    NAME_FA: "پیش فرض",
    CODE_PREFIX: "TL",
    CLOUD_SERVER: "http://cloud.taplife.ir:3030",
    COLORS: {
      PRIMARY: "#a4a3a1",
      SECONDARY: "#b3ba88",
      DARK: "#c3c3c3",
      MONOCHROME: {
        PRIMARY: {
          50: "#f9e9f0",
          100: "#f2d2df",
          200: "#e6a6bf",
          300: "#da79a0",
          400: "#ce4d80",
          500: "#802348",
          600: "#691c3b",
          700: "#54172f",
          800: "#3f1123",
          900: "#2a0b17",
        },
      },
    },
    WEBSOCKET_PORT: 3031,

    ICON: require("../images/icon.png"),
    LOGO_TYPE: require("../images/logo-type.png"),
    LOGO_TYPE_WHITE: require("../images/logo-type-white.png"),
    SPLASH: "../images/splash.png",
    LOADING: require("../../assets/images/loading-blue.gif"),
    SPLASH_BACKGROUND_COLOR: "#802348",
  };
  const brands = [
    // === Taplife Name ===
    {
      NAME_EN: "TapLife",
      NAME_FA: "تپ لایف",
      CODE_PREFIX: "TL",
      //
      ICON: require("../images/icon.png"),
      LOGO_TYPE: require("../images/logo-type.png"),
      LOGO_TYPE_WHITE: require("../images/logo-type-white.png"),
      SPLASH: "../images/splash.png",
      LOADING: require("../../assets/images/loading-blue.gif"),
      SPLASH_BACKGROUND_COLOR: "#802348",
      WEBSOCKET_PORT: 3031,
      //
      CLOUD_SERVER: "http://cloud.taplife.ir:3030",
      COLORS: {
        PRIMARY: "#802348",
        DARK: "#431326",
        SECONDARY: "#004040",
        THIRED: "#9C26B050",
        MONOCHROME: {
          PRIMARY: {
            50: "#f9e9f0",
            100: "#CD3C76",
            200: "#BE3269",
            300: "#A92D5E",
            400: "#942853",
            500: "#802348",
            600: "#6C1E3D",
            700: "#571932",
            800: "#431326",
            900: "#2F0E1B",
          },
        },
      },
    },
    // === MobiSmart Name ===
    {
      NAME_EN: "MobiSmart",
      NAME_FA: "مبی اسمارت",
      CODE_PREFIX: "MS",
      //
      ICON: require("../images/icon_mobismart.png"),
      LOGO_TYPE: require("../images/logo-type-mobismart.png"),
      LOGO_TYPE_WHITE: require("../images/logo-type-mobismart-white.png"),
      SPLASH: "../images/splash_mobismart.png",
      LOADING: require("../../assets/images/loading-green.gif"),
      SPLASH_BACKGROUND_COLOR: "#FFF",
      WEBSOCKET_PORT: 3031,

      //
      CLOUD_SERVER: "https://building.mobismart.ir",
      COLORS: {
        PRIMARY: "#a6ce39",
        SECONDARY: "#72bf44",
        DARK: "#055555",
        THIRED: "#9FD57D",
        MONOCHROME: {
          PRIMARY: {
            50: "#f0f9ea",
            100: "#CBE489",
            200: "#C2DE75",
            300: "#B9D961",
            400: "#AFD44D",
            500: "#a6ce39",
            600: "#98BE30",
            700: "#87A92B",
            800: "#779426",
            900: "#667F22",
          },
        },
      },
    },
    // === Default Name ===
    {
      NAME_EN: "Default",
      NAME_FA: "پیش فرض",
      CLOUD_SERVER: "http://bms.taplife.ir:3030",
      COLORS: {
        PRIMARY: "#a4a3a1",
        SECONDARY: "#b3ba88",
        DARK: "#c3c3c3",
        MONOCHROME: {
          PRIMARY: {
            50: "#f9e9f0",
            100: "#f2d2df",
            200: "#e6a6bf",
            300: "#da79a0",
            400: "#ce4d80",
            500: "#802348",
            600: "#691c3b",
            700: "#54172f",
            800: "#3f1123",
            900: "#2a0b17",
          },
        },
      },
    },
  ];
  result = brands.find(
    (key) => key.NAME_EN.toLowerCase() === brandName.toLowerCase()
  );
  return result;
};
const BRANDING = brandHandler(DEFAULT_BRAND_NAME);
//  === End Branding ===

const DEFAULT_PORTS_BRAND =
  BRANDING.NAME_EN === "TapLife" ? NON_SECURE_PORTS : SECURE_PORTS;
const NOTIFICATION_CHANNELS = {
  GUESTS_TIMEOUT: "GUESTS_TIMEOUT",
  DOORBELLS: "DOORBELLS",
  BREACH: "BREACH",
  SCENARIO_REPORTS: "SCENARIO_REPORTS",
};
const SCENARIO_CONDITIONS = {
  MAIN_SCHEDULE: "schedule",
  MAIN_DEVICE: "device",
  MAIN_VIRTUAL: "virtual",
  OPTIONAL_DEVICE_STATE: "deviceState",
  OPTIONAL_TIME_RANGE: "timeRange",
  OPTIONAL_AREA_ARMED: "areaArmed",
  OPTIONAL_USER_DEFINED_STATE: "areaUserDefinedState",
};

const WIDGETS = {
  USER_BALANCE: "USER_BALANCE",
};

const WIDGET_ACTIONS = {
  RECHARGE: "RECHARGE",
};

const MODULES = {
  RTSP: "RTSP",
  Elevator: "Elevator",
  Payment: "Payment",
  Reservation: "Reservation",
  GPIO: "GPIO",
};

const THERMOSTAT_MODE = {
  off: 0,
  heat: 1,
  cool: 2,
  auto: 3,
  auxiliary: 4,
  resume: 5,
  fan: 6,
  furnace: 7,
  dry: 8,
  moist: 9,
  autoChangeover: 10,
  energyHeat: 11,
  energyCool: 12,
  away: 13,
  reserved: 14,
  fullPower: 15,
};
const ZHVAC_MODE = {
  auto: 1,
  cool: 2,
  dry: 3,
  heat: 4,
  fan: 5,
};

const THERMOSTAT_FAN_MODE = {
  autoLow: 0,
  low: 1,
  autoHigh: 2,
  high: 3,
  autoMedium: 4,
  medium: 5,
  circulation: 6,
  humidityCirculation: 7,
  leftAndRight: 8,
  upAndDown: 9,
  quiet: 10,
  externalCirculation: 11,
  off: 128,
};
const ZHVAC_FAN_SPEED = {
  low: 1,
  mid: 2,
  high: 3,
  auto: 4,
};
const THERMOSTAT_OPERATING_STATE = {
  idle: 0,
  heating: 1,
  cooling: 2,
  fanOnly: 3,
  pendingHeat: 4,
  pendingCool: 5,
  ventEconomizer: 6,
  auxHeating: 7,
  secondStageHeating: 8,
  secondStageCooling: 9,
};

const THERMOSTAT_FAN_STATE = {
  off: 0,
  running: 1,
};

const MULTI_MEDIA_STATE = {
  stopped: 0,
  playing: 1,
  paused: 2,
};

const CURTAIN_DIRECTION = {
  vertical: 0,
  horizontal: 1,
};

const ACCESSCONTROL_DOOR_STATE = {
  Unknown: 0,
  Closed: 1,
  Opened: 2,
  HeldOpen: 3,
  ForcedOpen: 4,
};

export {
  DEFAULT_SERVER_ID,
  ACCESS_TOKEN,
  USER_QUICK_ACCESS,
  SERVER_LIST,
  SERVER_URL,
  SERVER_ID,
  SESSION_ID,
  BUILDING_ID,
  BUILDINGS,
  PROFILES_LIST,
  USER_ID,
  CLOUD_SERVER,
  USER_FULL_NAME,
  NOTIFICATION_CHANNELS,
  SCENARIO_CONDITIONS,
  WEB_MAX_WIDTH,
  WIDGETS,
  WIDGET_ACTIONS,
  LAST_UPDATE_CHECK,
  APP_VERSION,
  MODULES,
  THERMOSTAT_MODE,
  THERMOSTAT_FAN_MODE,
  THERMOSTAT_OPERATING_STATE,
  THERMOSTAT_FAN_STATE,
  WARNING_MIN_BATTERY,
  MULTI_MEDIA_STATE,
  CURTAIN_DIRECTION,
  BRANDING,
  WEATHER_API_KEY,
  WEATHER_CITY,
  DEFAULT_PORTS,
  SECURE_PORTS,
  NON_SECURE_PORTS,
  MIGRATION_VERSION,
  WEBSOCKET_PORT,
  ALL_PORTS,
  CHECK_SECURE_STORAGE,
  TRUE,
  FALSE,
  DEFAULT_PORTS_BRAND,
  PASSWORD_PATTERN,
  ACCESSCONTROL_DOOR_STATE,
  ZHVAC_MODE,
  ZHVAC_FAN_SPEED,
};
